// Close flags whose actions land a ticket in the Closed bucket and therefore
// require a closure reason to be selected from the dropdown.
export const CLOSE_FLAGS = new Set([
  "normal_close",
  "duplicate_close",
  "ts_successfull",
  "ts_success_agent",
  "freshdesk_close",
  "invalid_invoice",
  "warranty_expired",
  "not_connected",
  "service_denial",
  "product_validation_mismatch",
]);

// For specific close actions, pre-select the matching reason (by exact reason
// text from the ticket_closure_reason table) to save the agent a click.
export const FLAG_DEFAULT_REASON = {
  invalid_invoice: "Invalid Invoice",
  warranty_expired: "Out Of Warranty",
  not_connected: "Non Connected - 3 Attempts",
};

export const isCloseFlag = (flag) => CLOSE_FLAGS.has(flag);

// baseUrl is `https://<host>/connect`; the dropdown API is served under
// `/connect-complaint` on the same host. Only swap a trailing segment.
export const deriveComplaintBackendUrl = (baseUrl) => {
  if (!baseUrl) return baseUrl;
  return baseUrl.replace(/\/connect$/, "/connect-complaint");
};

// Returns the id of the reason whose text matches the flag's default, or null.
export const resolvePreselectReasonId = (flag, reasons) => {
  const wanted = FLAG_DEFAULT_REASON[flag];
  if (!wanted || !Array.isArray(reasons)) return null;
  const match = reasons.find((r) => r.reason === wanted);
  return match ? match.id : null;
};
